
import { isEqual } from "lodash";
import { mapActions, mapState, mapGetters } from "vuex";
import RateCardDialogue from "../dialogs/rate-card-dialogue.vue";
export default {
  components: { RateCardDialogue },
  props: {
    selectedRestaurant: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      deliveryType: ["home_delivery", "takeaway"],
      deliveryRadius: "",
      deliveryCharges: "",
      minOrderValue: "",
      isZomatoDeliveryAvailable: false,
      numberRule: [(v) => !!v || "Required"],
      selectedPartner: "",
      deliveryChargesPaidBy: "customer",
      initialFreeKm: "",
      minOrderValueForFreeDelivery: "",
      isDistanceBasedFreeDeliveryEnabled: false,
      isOrderValueBasedFreeDeliveryEnabled: false,
      deliveryConfigCopy: null,
      deliveryPartnerOptions: [
        {
          id: "own_delivery",
          label: "Own Delivery"
        },
        {
          id: "porter",
          label: "Porter"
        }
      ],
      deliveryChargePaidByOptions: [
        {
          id: "restaurant",
          label: "Restaurant"
        },
        {
          id: "customer",
          label: "Customer"
        },
        {
          id: "shared",
          label: "Mutually Shared"
        }
      ],
      deliveryOptions: [
        { label: "Takeaway Orders", value: "takeaway", checkbox: true },
        {
          label: "Home Delivery Orders",
          value: "home_delivery",
          checkbox: true
        }
      ],
      restaurantContribution: 30,
      assignmentDelayType: "immediate",
      customDelay: 10,
      assignmentDelayTypeOptions: [
        { value: "immediate", label: "Right after the order is accepted" },
        { value: "custom", label: "Set a custom delay from order acceptance" },
        { value: "prepared", label: "As soon as the order prepared" }
      ]
    };
  },

  async mounted() {
    this.getSavedConfiguration();
    try {
      const response = await this.getServiceability();
      this.isZomatoDeliveryAvailable = response.data;
    } catch (error) {
      this.$nuxt.$emit("show-error-toast", error);
    }
  },

  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["getChannelId"]),
    showHomeDeliverySettings() {
      return this.isCheckboxChecked("home_delivery");
    },
    customerDeliveryChargeContribution() {
      return 100 - this.restaurantContribution;
    },
    hasUnsavedChanges() {
      return !isEqual(this.getCurrentConfig(), this.getSavedConfig());
    },
    formattedDelay() {
      return `${this.customDelay.toString().padStart(2, "0")}:00 Min`;
    },
    maxFoodPreparationTime() {
      return (
        (this.selectedRestaurant?.settings.health_metrics_preparation_time ||
          0) / 60
      );
    },
    computedCurrencySymbol() {
      return this.locationDetails?.location_currency === "INR"
        ? "₹"
        : this.locationDetails?.location_currency;
    }
  },
  methods: {
    ...mapActions("restaurant", [
      "updateIntegrationStatus",
      "updateDeliveryConfiguration",
      "getLocationDetails",
      "getDeliveryConfiguration",
      "getServiceability",
      "getLocationDetails"
    ]),

    selectCheckbox(e, value) {
      const index = this.deliveryType.indexOf(value);
      if (index === -1) {
        this.deliveryType.push(value);
      } else {
        this.deliveryType.splice(index, 1);
      }
    },
    increaseDeliveryRadius() {
      this.deliveryRadius += 1;
    },
    decreaseDeliveryRadius() {
      if (this.deliveryRadius > 1) {
        this.deliveryRadius -= 1;
      }
    },
    increaseDelay() {
      this.customDelay += 5;
    },
    decreaseDelay() {
      if (this.customDelay > 5) {
        this.customDelay -= 5;
      }
    },
    isDisabledPartner(option) {
      return option.id === "zomato" && !this.isZomatoDeliveryAvailable;
    },
    isCheckboxChecked(value) {
      return this.deliveryType.indexOf(value) > -1;
    },
    async getSavedConfiguration() {
      try {
        const response = await this.getDeliveryConfiguration(
          this.getChannelId("whatsapp")
        );

        if (response && response.data) {
          this.deliveryConfigCopy = JSON.parse(JSON.stringify(response.data));

          this.deliveryType = JSON.parse(
            JSON.stringify(this.deliveryConfigCopy.delivery_type)
          );
          this.deliveryOptions = this.deliveryOptions.map((option) => {
            option.checkbox = this.deliveryType.includes(option.value);
            return option;
          });
          this.deliveryRadius = this.deliveryConfigCopy.delivery_radius;
          this.minOrderValue = this.deliveryConfigCopy.minimum_order_value;
          this.selectedPartner = this.deliveryConfigCopy.delivery_partner;

          this.deliveryCharges = this.deliveryConfigCopy.delivery_charge;
          this.deliveryChargesPaidBy = this.deliveryConfigCopy.paid_by;
          this.initialFreeKm = this.deliveryConfigCopy.delivery_charge_from;
          this.minOrderValueForFreeDelivery =
            this.deliveryConfigCopy.free_delivery_order_value;

          const chargeBreakdown = this.deliveryConfigCopy.charge_breakdown;
          if (chargeBreakdown) {
            this.restaurantContribution = chargeBreakdown.restaurant;
          }
          this.isOrderValueBasedFreeDeliveryEnabled = Boolean(
            this.deliveryConfigCopy.free_delivery_order_value
          );
          this.isDistanceBasedFreeDeliveryEnabled = Boolean(
            this.deliveryConfigCopy.delivery_charge_from
          );

          this.assignmentDelayType =
            this.deliveryConfigCopy?.assignment_delay_type;
          if (this.assignmentDelayType === "custom") {
            this.customDelay =
              this.deliveryConfigCopy?.assignment_delay_minutes;
          }
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    },
    async saveChange() {
      this.loading = true;

      let payload = this.getCurrentConfig();

      try {
        const response = await this.updateDeliveryConfiguration({
          channelId: this.getChannelId("whatsapp"),
          payload
        });
        if (response.status === 200) {
          this.getLocationDetails(false);
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        } else {
          $nuxt.$emit("show-error-toast", response);
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      } finally {
        this.loading = false;
        this.getSavedConfiguration();
      }
    },

    getSavedConfig() {
      if (!this.deliveryConfigCopy) {
        return null;
      }
      const {
        delivery_type,
        delivery_partner,
        minimum_order_value,
        delivery_radius,
        delivery_charge,
        delivery_charge_from,
        free_delivery_order_value,
        delivery_flat_charge,
        paid_by,
        charge_breakdown,
        assignment_delay_type,
        assignment_delay_minutes
      } = this.deliveryConfigCopy;
      return {
        delivery_type,
        delivery_partner,
        minimum_order_value,
        delivery_radius,
        delivery_charge,
        delivery_charge_from,
        free_delivery_order_value,
        delivery_flat_charge,
        paid_by,
        charge_breakdown,
        assignment_delay_type,
        assignment_delay_minutes
      };
    },

    getCurrentConfig() {
      let currentConfig = {
        delivery_type: this.deliveryType,
        delivery_partner: this.selectedPartner,
        minimum_order_value: this.minOrderValue,
        delivery_radius: this.deliveryRadius,
        delivery_charge: this.deliveryCharges,
        delivery_charge_from: this.isDistanceBasedFreeDeliveryEnabled
          ? this.initialFreeKm
          : null,
        free_delivery_order_value: this.isOrderValueBasedFreeDeliveryEnabled
          ? this.minOrderValueForFreeDelivery
          : null,
        delivery_flat_charge: null,
        paid_by: this.deliveryChargesPaidBy,
        charge_breakdown: {
          restaurant: 0,
          customer: 100
        },

        assignment_delay_type: this.assignmentDelayType,
        assignment_delay_minutes:
          this.assignmentDelayType === "custom" ? this.customDelay : null
      };

      if (this.deliveryChargesPaidBy === "shared") {
        currentConfig.charge_breakdown = {
          restaurant: this.restaurantContribution,
          customer: this.customerDeliveryChargeContribution
        };
      }

      return currentConfig;
    }
  }
};
